const angular = require('angular');

const { spinnerComponentDefinition } = require('./spinner.component');
const { smallSpinnerComponentDefinition } = require('./small-spinner.component');

angular.module('oly.common')
    .component('wowLoadingSpinner', spinnerComponentDefinition)
    .component('wowSmallSpinner', smallSpinnerComponentDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/loading-spinner/index.js